import React, { CSSProperties, ReactNode } from 'react';

type FlexDirection = 'row' | 'row-reverse' | 'column' | 'column-reverse';
type FlexWrap = 'nowrap' | 'wrap' | 'wrap-reverse';
type JustifyContent =
  | 'start'
  | 'end'
  | 'center'
  | 'space-around'
  | 'space-between'
  | 'space-evenly';
type AlignItems = 'start' | 'end' | 'center' | 'baseline' | 'stretch';

interface FlexProps {
  children?: ReactNode;
  direction?: FlexDirection;
  wrap?: FlexWrap;
  justify?: JustifyContent;
  align?: AlignItems;
  gap?: number | string;
  style?: CSSProperties;
  className?: string;
  /** 其他 div 原生属性 */
  [key: string]: any;
}

const justifyContentMap: Record<JustifyContent, string> = {
  start: 'flex-start',
  end: 'flex-end',
  center: 'center',
  'space-around': 'space-around',
  'space-between': 'space-between',
  'space-evenly': 'space-evenly',
};

const alignItemsMap: Record<AlignItems, string> = {
  start: 'flex-start',
  end: 'flex-end',
  center: 'center',
  baseline: 'baseline',
  stretch: 'stretch',
};

const Flex: React.FC<FlexProps> = ({
  children,
  direction = 'row',
  wrap = 'nowrap',
  justify = 'start',
  align = 'center',
  gap,
  style,
  className,
  ...rest
}) => {
  const flexStyle: CSSProperties = {
    display: 'flex',
    flexDirection: direction,
    flexWrap: wrap,
    justifyContent: justifyContentMap[justify],
    alignItems: alignItemsMap[align],
    gap,
    ...style,
  };

  return (
    <div className={className} style={flexStyle} {...rest}>
      {children}
    </div>
  );
};

export default Flex;
